import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { ApiService } from '../../root-services/api.service';
import { CurrentUser } from './../../models/current-user';
import { AccountSettings } from './../../models/account-settings';
import { AllPermissions } from './../../models/permissions';
import { CurrentUserService } from './current-user.service';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../../models/permission';

const permissionsRequiringDashboard = [
  'sessionManagement',
  'editJourneys',
  'editResources',
  'nomadicAdministration',
  'editionAdministration'
];

@Injectable()

export class PermissionsService {
  private permissions: AllPermissions;
  public simplifiedSessionManagement: boolean;
  public simplifiedJourneyManagement: boolean;

  constructor(private currentUserService: CurrentUserService, private api: ApiService) {
    this.currentUserService.getUserData().subscribe(user => {
      this.simplifiedJourneyManagement = user.roles.filter(
        role => role[0] == 'AXAEntityAdmin').length > 0;
    });
  }

  public checkPermission(permission: Permission): Observable<boolean> {
    return this.retrievePermissions().map(permissions => !!permissions[permission]);
  }

  private snakeToCamel = (str) => {
    return str.replace(/([_][a-z])/g,(group) => {
      return group.toUpperCase().replace('_', '')
    });
  };

  public retrievePermissions(): Observable<AllPermissions> {
    return this.currentUserService.getUserData().map(currentUser => {
      // Turn role (user level) into a table of user permissions
      console.log('Setting user levels');
      const access = currentUser.level;
      let permissions: AllPermissions;
      switch (access) {
        case ('sales'):
          permissions = {
            nomadicAdministration: true,
            editionAdministration: true,
            editionAnalytics: true,
            programAnalytics: true,
            programAdministration: true,
            groupAnalytics: true,
            analyticsAccess: true,
            anyAdminOrAnalytics: true,
            subscriptionTeamAnalytics: false,
            editJourneys: true,
            cloneJourney: true,
            createJourney: true,
            sessionManagement: false,
            dashboard: true,
            editResources: true,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: true,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: true,
            bulkDeleteUsers: false,
          }
          break;
        case ('edition'):
          permissions = {
            nomadicAdministration: false,
            editionAdministration: true,
            editionAnalytics: true,
            programAnalytics: true,
            programAdministration: true,
            groupAnalytics: true,
            analyticsAccess: true,
            anyAdminOrAnalytics: true,
            subscriptionTeamAnalytics: false,
            editJourneys: true,
            cloneJourney: true,
            createJourney: true,
            sessionManagement: false,
            dashboard: true,
            editResources: false,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: false,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: false,
            bulkDeleteUsers: false,
          }
          break;
        case ('edition_analytics'):
          permissions = {
            nomadicAdministration: false,
            editionAdministration: false,
            editionAnalytics: true,
            programAnalytics: true,
            programAdministration: false,
            groupAnalytics: true,
            analyticsAccess: true,
            anyAdminOrAnalytics: true,
            subscriptionTeamAnalytics: false,
            editJourneys: true,
            cloneJourney: false,
            createJourney: false,
            sessionManagement: false,
            dashboard: false,
            editResources: false,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: false,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: false,
            bulkDeleteUsers: false,
          }
          break;
        case ('program'):
          permissions = {
            nomadicAdministration: false,
            editionAdministration: false,
            editionAnalytics: false,
            programAnalytics: true,
            programAdministration: true,
            groupAnalytics: true,
            analyticsAccess: true,
            anyAdminOrAnalytics: true,
            subscriptionTeamAnalytics: false,
            editJourneys: true,
            cloneJourney: false,
            createJourney: false,
            sessionManagement: false,
            dashboard: true,
            editResources: false,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: false,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: false,
            bulkDeleteUsers: false,
          }
          break;
        case ('group'):
          permissions = {
            nomadicAdministration: false,
            editionAdministration: false,
            editionAnalytics: false,
            programAnalytics: false,
            programAdministration: false,
            groupAnalytics: true,
            analyticsAccess: true,
            anyAdminOrAnalytics: true,
            subscriptionTeamAnalytics: false,
            editJourneys: true,
            cloneJourney: false,
            createJourney: false,
            sessionManagement: false,
            dashboard: false,
            editResources: false,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: false,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: false,
            bulkDeleteUsers: false,
          }
          break;
        case ('subscription_team'):
          permissions = {
            nomadicAdministration: false,
            editionAdministration: false,
            editionAnalytics: false,
            programAnalytics: false,
            programAdministration: false,
            groupAnalytics: false,
            analyticsAccess: true,
            anyAdminOrAnalytics: true,
            subscriptionTeamAnalytics: true,
            editJourneys: true,
            cloneJourney: false,
            createJourney: false,
            sessionManagement: false,
            dashboard: false,
            editResources: false,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: false,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: false,
            bulkDeleteUsers: false,
          }
          break;
        default:
          // If none match, no permissions
          permissions = {
            nomadicAdministration: false,
            editionAdministration: false,
            editionAnalytics: false,
            programAnalytics: false,
            programAdministration: false,
            groupAnalytics: false,
            analyticsAccess: false,
            anyAdminOrAnalytics: false,
            subscriptionTeamAnalytics: false,
            editJourneys: true,
            cloneJourney: false,
            createJourney: false,
            sessionManagement: false,
            dashboard: false,
            editResources: false,
            impersonate: false,
            listSubscriptions: false,
            manageSubscriptions: false,
            readSamlConfig: false,
            writeSamlConfig: false,
            editProgramContent: false,
            manageSubscriptionUsers: true,
            axaEntityUserManagement: false,
            manageOwnAdminApiKey: false,
            grantEditionAdmin: false,
            bulkDeleteUsers: false,
          }
          break;
      }
      // Override level based permission with any ad hoc ones
      if (currentUser.permissions.length) {
        currentUser.permissions.forEach(key => {
          key = this.snakeToCamel(key);
          permissions[this.snakeToCamel(key)] = true;
          if (permissionsRequiringDashboard.indexOf(key) > -1) {
            permissions.dashboard = true;
          }
        });
      }
      if (permissions['sessionManagement'] && !(access === 'sales' || access === 'edition')) {
        this.simplifiedSessionManagement = true;
      }
      return permissions;
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/services/permissions.service.ts